// extracted by mini-css-extract-plugin
module.exports = {"root":"OptionButtonGroup_root__1K__O","btn":"OptionButtonGroup_btn__18MLA","selected":"OptionButtonGroup_selected__1Nw2k"};